<template>
  <div class="view view-short-video" :class="{'new-distance':!isInNative}">
    <div class="shop-header">
      <EntitySecond :itemData="storeInfo"/>
      <Nav :navData="menuInfo || []"/>
    </div>

    <template v-if="tipTitle">
      <placeholder
        slot="no-results"
        :icon="tipIcon"
        :title="tipTitle"
      />
    </template>
    <template v-else>
      <div class="g-content">
        <short-video-item v-for="(item, index) of itemsData" :key="index" :itemData="item" :storeKey="storeKey" />
        <zs-infinite ref="infinite" @infinite="onLoadData" :isAutoLoad="true" noResultText=""
                     no-more-text="没有更多内容了">
        </zs-infinite>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import detect from '@iqiyi-kpp/utility/es/detector'

  import Nav from '../../components/cards/Nav'
  import EntitySecond from '../../components/items/Entity2'
  import ShortVideoItem from './short-video-item.vue'
  import Placeholder from '@/components/placeholder.vue'
  import Api from "../../service/api"
  import pv from '@/service/pingback/pv'
  import store from "../../store"
  // import mockData from './mock'

  const pageSize = 10;

  export default {
    components: {
      Nav,
      EntitySecond,
      ShortVideoItem,
      Placeholder
    },

    data() {
      return {
        itemsData: [],
        pageIndex: 0,
        dataTotal: 0,
        tipIcon: 'play',
        tipTitle: '',
        storeKey: ''
      }
    },

    computed: {
      ...mapGetters('category', {
        storeInfo: 'getStoreInfo',
        menuInfo: 'getMenuInfo'
      }),

      isInNative() {
        return detect.iqiyi() || detect.zhishi()
      }
    },

    created() {
      if(this.storeInfo.key){
        pv.send({
          rpage:`knowledge_h5_shop_${this.storeInfo.key}_小知识`,
          v: 1
        })
      }

      this.$callNative.prepare()
    },

    mounted() {
    },

    methods: {

      setTip(icon, title) {
        this.tipIcon = icon
        this.tipTitle = title
      },

      async prepare() {
        let qiyihaoId = ''
        if (!this.storeInfo.iqiyiId) {
          const data = await this.getShopData()
          qiyihaoId = String(data.storeInfo.iqiyiId)
        } else {
          qiyihaoId = String(this.storeInfo.iqiyiId)
        }
        if (!qiyihaoId) {
          throw new Error('invalid qiyihaoId')
        }
        this.qiyihaoId = qiyihaoId
      },

      async getShopData() {
        const param = this.$route.params.pageId;
        let arr = []
        if (param) {
          arr = param.split('.html');
        }
        let data = await Api.read(arr[0], '', false)
        this.navData = data.tabs || []
        pv.send({
          rpage: `knowledge_h5_shop_${data.storeInfo.key}_小知识`,
          v: 1
        })

        this.storeKey = data.storeInfo.key

        //存储店铺和菜单信息
        store.dispatch('category/storeInfo', {
          storeInfo: data.storeInfo || {}
        })
        store.dispatch('category/menuInfo', {
          menuInfo: this.navData
        })
        return data
      },

      async load(pageIndex) {
        try {
          const o = await this.$fetch.get({
            url: '/api/v1/dynamic/store/svideo/list',
            params: {
              pageIndex,
              pageSize,
              iqiyihaoId: this.qiyihaoId
            }
          })
          if (!o || o === 'null') {
            this.setTip('play', '店铺还没有短视频哦')
            return
          }

          this.dataTotal = o.totalCount
          this.itemsData = this.itemsData.concat(o.videoList || [])
          this.pageIndex = pageIndex

          if (pageIndex === 1 && this.itemsData.length === 0) {
            this.setTip('play', '店铺还没有短视频哦')
          }
        } catch (err) {
          if (pageIndex === 1) {
            if (err.status === 'A00003') {
              this.setTip('404', '服务请求异常，请稍后再试！')
            } else {
              this.setTip('404', '你的网络有问题哦，请检查网络设置')
            }
          } else {
            this.$toast.info(`你的网络有问题哦，请检查网络设置`)
          }
        }
      },

      async onLoadData() {
        await this.prepare()
        await this.load(this.pageIndex + 1)

        const $infinite = this.$refs.infinite
        const pageTotal = Math.ceil(this.dataTotal / pageSize)
        const length = this.itemsData.length

        if (this.pageIndex === 1) {
          if (length === 0) {
            $infinite.none();
          } else if (length === this.dataTotal) {
            $infinite.complete(false);
          } else {
            $infinite.loaded();
          }
        } else {
          if (this.pageIndex >= pageTotal) {
            $infinite.complete();
          } else {
            $infinite.loaded();
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .view-short-video {
    &.view {
      margin-top: 0;
    }

    &.new-distance {
      margin-top: -14px !important;
    }
  }
</style>
